<template>
  <div class="relative cursor-pointer rounded-lg hover:shadow-xl">
    <img :src="boat.background_image.url | getImagePath" loading="lazy"
      :alt="boat.background_image.name"
      class="object-cover w-full rounded-lg h-72">
    <div class="absolute bottom-0 left-0 m-5 text-white text-left">
      <ebr-h2 :content="boat.name" />
      <div class="flex md:items-center justify-center md:justify-start font-light my-4">
        <ebr-boat-portata
          :containerClass="'flex items-center'"
          :content="`${boat['information_'+language].seats}`" />
        <ebr-span :content="'|'" class="mx-1 md:mx-4" />
        <ebr-boat-patente v-if="boat['information_'+language].boat_type === 'con_patente'"
          :containerClass="'flex items-center'"
          :content="$t('boat_detail.types[0]')" />
        <ebr-boat-senza-patente v-else
          :containerClass="'flex items-center'"
          :content="$t('boat_detail.types[1]')" />
        <ebr-span :content="'|'" class="mx-1 md:mx-4" />
        <ebr-boat-prezzo
          :containerClass="'flex items-center'"
          :content="boat['information_'+language].deposit" />
      </div>
    </div>
  </div>
</template>

<script>
import H2Vue from '../../atoms/typography/H2.vue';
import IconTextPortataPersoneVue from '../../atoms/icons-with-text/IconTextPortataPersone.vue';
import IconTextPatenteVue from '../../atoms/icons-with-text/IconTextPatente.vue';
import IconTextPrezzoVue from '../../atoms/icons-with-text/IconTextPrezzo.vue';
import SpanVue from '../../atoms/typography/Span.vue';
import IconTextSenzaPatenteVue from '../../atoms/icons-with-text/IconTextSenzaPatente.vue';

export default {
  props: {
    boat: {
      type: Object,
      required: true,
    },
  },
  computed: {
    language() {
      return this.$store.state.language;
    },
  },
  components: {
    'ebr-h2': H2Vue,
    'ebr-boat-portata': IconTextPortataPersoneVue,
    'ebr-boat-patente': IconTextPatenteVue,
    'ebr-boat-senza-patente': IconTextSenzaPatenteVue,
    'ebr-boat-prezzo': IconTextPrezzoVue,
    'ebr-span': SpanVue,
  },
};
</script>

<style>

</style>
